import { join } from "path";
import React from "react";
import { Link } from "react-navi";
import styles from "./Pagination.module.css";

function Pagination({ blogRoot, pageCount, pageNumber }) {
  return (
    <nav className={styles.Pagination} aria-label="Blog pagination">
      {pageNumber !== 1 && (
        <Link
          className={styles.previous}
          href={join(blogRoot, "page", String(pageNumber - 1))}
        >
          ← Previous
        </Link>
      )}
      <span className={styles.pages}>
        Page {pageNumber} of {pageCount}
      </span>
      {pageNumber < pageCount && (
        <Link
          className={styles.next}
          href={join(blogRoot, "page", String(pageNumber + 1))}
        >
          Next →
        </Link>
      )}
    </nav>
  );
}

export default Pagination;
